/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SubmitBiometricsRequest = {
  properties: {
    sdkToken: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
